var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJuvo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9099A3",
    fillRule: "evenodd",
    d: "M10.515.204a2.63 2.63 0 012.609 2.608v8.89c0 3.431-2.79 6.22-6.16 6.22a6.226 6.226 0 01-6.222-6.22v-1.665a2.63 2.63 0 012.61-2.61 2.63 2.63 0 012.608 2.61v1.665a.93.93 0 00.943.943.93.93 0 00.943-.943v-8.89c0-1.424 1.184-2.608 2.669-2.608zm14.187 3.552a2.63 2.63 0 012.609 2.608v5.338c0 3.431-2.79 6.22-6.16 6.22-3.432 0-6.161-2.789-6.161-6.22V6.364a2.63 2.63 0 012.609-2.608 2.63 2.63 0 012.608 2.608v5.338a.93.93 0 00.944.943.93.93 0 00.943-.943V6.364a2.63 2.63 0 012.608-2.608zM36.983 5.24c.602-1.305 2.127-1.907 3.432-1.305a2.64 2.64 0 011.304 3.492l-4.033 8.89c-.422.943-1.305 1.605-2.368 1.605h-.12a2.624 2.624 0 01-2.248-1.545l-4.034-8.95c-.602-1.305 0-2.91 1.305-3.492 1.304-.602 2.85 0 3.431 1.305l1.666 3.672 1.665-3.672zm11.98-1.485c3.432 0 6.16 2.789 6.16 6.22v1.786c0 3.432-2.789 6.221-6.16 6.221-3.431 0-6.16-2.79-6.16-6.22V9.975c-.06-3.431 2.729-6.22 6.16-6.22zm0 5.217a.93.93 0 00-.943.943v1.786a.93.93 0 00.943.943.942.942 0 00.943-.943V9.916a.93.93 0 00-.943-.943z",
    clipRule: "evenodd"
  })));
}

export default SvgJuvo;